// extracted by mini-css-extract-plugin
export default {"labelContainer":"Reactions_labelContainer__+rd+o","tagsContainer":"Reactions_tagsContainer__F1C9S"};